import {
    ActivityRecordType,
    HomeCareLeadId,
    PlacementId,
    ReferenceBusinessId,
    ReferenceContactId,
} from "@sp-crm/core";
import type { AppRouter } from "@sp-crm/server/rpc";
import type { inferProcedureOutput } from "@trpc/server";

export type CalendarEventDto = inferProcedureOutput<
    AppRouter["calendarEvents"]["create"]
>;

interface ActivityParentBase {
    name: string;
    address: string | null;
}

export type VisitParent =
    | ({ kind: "contact"; id: ReferenceContactId } & ActivityParentBase)
    | ({ kind: "organization"; id: ReferenceBusinessId } & ActivityParentBase);

export type ActivityParent =
    | VisitParent
    | ({ kind: "client"; id: PlacementId } & ActivityParentBase)
    | ({ kind: "homeCareLead"; id: HomeCareLeadId } & ActivityParentBase);

export type VisitParentKind = VisitParent["kind"];

export type ActivityParentKind = ActivityParent["kind"];

export const activityRecordTypeForActivityParentKind = (
    kind: ActivityParentKind,
): ActivityRecordType => {
    switch (kind) {
        case "contact":
            return "referenceContact";
        case "organization":
            return "referenceBusiness";
        case "client":
            return "placement";
        case "homeCareLead":
            return "homeCare";
    }
    const exhaustiveCheck: never = kind;
    throw new Error(`Unhandled activity parent kind ${String(exhaustiveCheck)}`);
};

export const visitParentFor = (parent: ActivityParent): VisitParent | null =>
    parent.kind === "contact" || parent.kind === "organization" ? parent : null;

interface VisitParentIds {
    parentId?: string | null;
    businessId?: string | null;
}

export const visitParentKind = (visit: VisitParentIds): VisitParentKind =>
    visit.businessId !== null &&
    visit.businessId !== undefined &&
    visit.businessId === visit.parentId
        ? "organization"
        : "contact";
